import type { SupervisorFindingWithRow } from '@avisoma/shared';
import { SupervisorFindingBadge } from '../../SupervisorFindingBadge';
import { Td, Th } from './cells';

/** Row index in one family's `consolidatedExtraction` array → the supervisor findings on that row. */
export type RowFindings = Map<number, SupervisorFindingWithRow[]>;

/** Leading, label-less header for the supervisor marker column. */
export function FindingMarkerHeader() {
  return (
    <Th className="w-6" title="Supervisor findings">
      <span className="sr-only">Supervisor findings</span>
    </Th>
  );
}

/**
 * One compact badge per finding on the row. A click on a badge stops at the cell so it
 * does not also open the row inspector; an empty cell stays part of the clickable row.
 */
export function FindingMarkerCell({ findings }: { findings: SupervisorFindingWithRow[] | undefined }) {
  const hasFindings = findings !== undefined && findings.length > 0;
  return (
    <Td className="w-6" onClick={hasFindings ? (e) => e.stopPropagation() : undefined}>
      {hasFindings && (
        <span className="inline-flex gap-0.5">
          {findings.map((f) => (
            <SupervisorFindingBadge key={f.id} finding={f} compact />
          ))}
        </span>
      )}
    </Td>
  );
}
